import styled from '@emotion/styled';
import { Modal, ModalClose, DialogActions, DialogContent, DialogTitle } from '@mui/joy';
import ModalDialog from '@mui/joy/ModalDialog';
import { ReactNode, JSX } from 'react';

export type ModalProps = {
  body?: ReactNode;
  actions?: (onClose?: () => void) => ReactNode;
  description?: string;
  noCloseButton?: boolean;
  onClose?: () => void;
  open?: boolean;
  title?: string;
};

/**
 * Note: For the modal to work as expected if you wrap it, you need to forward the onClose prop
 */
export const LayoutModal = ({
  open,
  onClose,
  title,
  description,
  body,
  actions,
  noCloseButton,
}: ModalProps): JSX.Element => {
  const isOpen = open ?? true;

  return (
    <Modal
      open={isOpen}
      onClose={() => (onClose ? onClose() : null)}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'black',
            opacity: 0.5,
          },
        },
      }}
    >
      <ModalDialogStyled>
        {!noCloseButton && <ModalCloseStyled variant="plain" />}
        {(title || description) && <DialogTitle level="h2">{title}</DialogTitle>}
        {body && <DialogContent>{body}</DialogContent>}

        {actions && <DialogActionsStyled>{actions(onClose)}</DialogActionsStyled>}
      </ModalDialogStyled>
    </Modal>
  );
};

const ModalCloseStyled = styled(ModalClose)`
  margin: 1em;
`;

const ModalDialogStyled = styled(ModalDialog)`
  min-width: 500px;
`;

const DialogActionsStyled = styled(DialogActions)`
  justify-content: space-between;
`;
